var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14019 11.2318C6.56446 11.5854 6.62179 12.2159 6.26822 12.6402L5.13504 14H14.5C14.7652 14 15.0196 14.1054 15.2071 14.2929L16.2071 15.2929C16.5976 15.6834 16.5976 16.3166 16.2071 16.7071C15.8166 17.0977 15.1834 17.0977 14.7929 16.7071L14.0858 16H5.80141L9.13324 18.7261C9.56069 19.0758 9.62369 19.7058 9.27396 20.1333C8.92423 20.5607 8.29421 20.6237 7.86677 20.274L2.36677 15.774C2.16029 15.605 2.02988 15.3606 2.00453 15.095C1.97918 14.8295 2.06099 14.5648 2.23178 14.3598L4.73178 11.3598C5.08535 10.9356 5.71591 10.8782 6.14019 11.2318Z",
    fill: "#EEF2F9",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8598 12.2682C17.4355 11.9146 17.3782 11.2841 17.7318 10.8598L18.865 9.49997H9.5C9.23478 9.49997 8.98043 9.39462 8.79289 9.20708L7.79289 8.20708C7.40237 7.81656 7.40237 7.18339 7.79289 6.79287C8.18341 6.40234 8.81658 6.40234 9.2071 6.79287L9.91421 7.49997H18.1986L14.8668 4.77393C14.4393 4.4242 14.3763 3.79418 14.726 3.36674C15.0758 2.93929 15.7058 2.87629 16.1332 3.22602L21.6332 7.72602C21.8397 7.89495 21.9701 8.13938 21.9955 8.40495C22.0208 8.67052 21.939 8.93521 21.7682 9.14016L19.2682 12.1402C18.9147 12.5644 18.2841 12.6218 17.8598 12.2682Z",
    fill: "#EEF2F9",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.6ee3d6dd.svg";
export { ForwardRef as ReactComponent };